import React, { useContext, useEffect, useState } from 'react'
import Button from '../components/button'
import Top from '../components/top'
import Table from '../components/table'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthProvider'
import { DetailsContext } from '../contexts/DetailsContext'

const Complaints = (props) => {
    const [showModal, setShowModal] = useState(false);
    const {
      user,
      setUser,
      isLogged,
      setIsLogged,
      login,
      logout
    } = useContext(AuthContext)

    const { complaints } = useContext(DetailsContext)
    
    const navigate = useNavigate()
    useEffect(() => {
      if (!isLogged) {
        navigate('/')
      }
    }, [isLogged])

    const inputs = [
        {
          name: "date",
          icon: 'fa-solid fa-cube',
          type: 'text',
          placeholder: 'Enter Date',
        },
        {
          name: "status",
          icon: 'fa-solid fa-user',
          type: 'select',
          vals: [
            {name: 'Pending', option:'Pending'},
            {name: 'Completed', option:'Completed'},
          ],
        }
      ]

    props.setNavShow(true)
    function formatNumber(number) {
      return number.toLocaleString('en-US', { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2 
      });
  }
    const userColumns = ['User', 'Type', 'Effected User', 'Status', 'Date', 'ID']
    function addUsers(){
        window.location.replace('/edit')
    }
    const link = 'https://xgramm.com/xgramm_backend/admin/complaints.php'
  return (
    <div  style={{position: 'relative'}} className='w3-col l9 w3-right m9 s12 main'>
        <Top showModal={showModal} setShowModal={setShowModal} isAdd={false} value='Add New Complaints' name='Complaints'/>
        <div className="w3-container">
        <Table tableName='actions' link={link} inputs={inputs} showModal={showModal} setShowModal={setShowModal} name='All Complaints' columns={userColumns} data={complaints ? complaints : []} summary={false} edit={true} />
        </div>
    </div>
  )
}

export default Complaints